// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2BG6S","text":"SelectPayment_text__2qICr","title":"SelectPayment_title__2NwpW","btn":"SelectPayment_btn__36iYg"};